import _ from 'lodash'
import { PROGRAM_SEARCH_CAT_ID, } from '../constants/other'
import { isValidCoord, getWashingtonBounds, } from '../util/mapCalcs'

function getProgramCategoryId (program) {
  let foundCat = null
  if (_.isArray(program.categories)) {
    let i = 0
    while (i < program.categories.length && !foundCat) {
      if (PROGRAM_SEARCH_CAT_ID[program.categories[i]]) {
        foundCat = PROGRAM_SEARCH_CAT_ID[program.categories[i]]
      }
      i++
    }
  }
  if (!foundCat) {
    console.warn('Couldnt find category for', program)
  }
  return foundCat
}

export const mapOnlyProgramLocationData = (programs) => {
  let addressIndex = 0
  if (!_.isArray(programs) || programs.length === 0){
    return []
  }

  // WA bounds to compare against
  const waBounds = getWashingtonBounds()

  // Reduce programs 
  const reducedPrograms = programs.reduce((progAcc, prog) => {
    // if the program is null or it doesn't have addresses, skip it
    if (!prog || !_.isArray(prog.addresses) || prog.addresses.length === 0) {
      return progAcc
    }

    const mappedAddresses = prog.addresses.reduce((addrAcc, addr) => {
      // if the address is null or the coords are invalid, skip it
      if (!addr || !addr.lat || !addr.lon || !isValidCoord(addr.lat, addr.lon)) {
        return addrAcc
      }

      const latLng = { lat: addr.lat, lng: addr.lon, }
      // if the address is outside of WA, skip it
      if (!waBounds.contains(latLng)) {
        return addrAcc
      }

      // create location object to return
      const mapped = {
        index                 : addressIndex,
        program_occupation_id : prog.program_occupation_id,
        program_name          : prog.program_name,
        occupation_name       : prog.occupation_name,
        program_type          : prog.type,
        title                 : prog.title,
        categoryId            : getProgramCategoryId(prog),
        ...addr,
      } 
      // add to accumulator array
      addrAcc.push(mapped)
      // increment index
      addressIndex += 1
      return addrAcc
    }, [])
    // add mapped addresses to accumulator
    progAcc = [ ...progAcc, ...mappedAddresses, ]
    return progAcc
  }, [])

  return reducedPrograms
}

export const mapProgramLocationData = (programs) => {
  let addressIndex = 0
  if (!_.isArray(programs) || programs.length === 0){
    return []
  }

  // WA bounds to compare against
  const waBounds = getWashingtonBounds()

  // Reduce programs 
  const reducedPrograms = programs.reduce((progAcc, prog) => {
    // if the program is null or it doesn't have addresses, skip it
    if (!prog || !_.isArray(prog.addresses) || prog.addresses.length === 0) {
      return progAcc
    }

    const mappedAddresses = prog.addresses.reduce((addrAcc, addr) => {
      // if the address is null or the coords are invalid, skip it
      if (!addr || !addr.lat || !addr.lon || !isValidCoord(addr.lat, addr.lon)) {
        return addrAcc
      }

      const latLng = { lat: addr.lat, lng: addr.lon, }
      // if the address is outside of WA, skip it
      if (!waBounds.contains(latLng)) {
        return addrAcc
      }

      // initialize bounds if necessary
      if (!progAcc.bounds) {
        progAcc.bounds = new google.maps.LatLngBounds()
      }
      // extend bounds to include this location
      progAcc.bounds = progAcc.bounds.extend(latLng)

      // create location object to return
      const mapped = {
        index                 : addressIndex,
        program_occupation_id : prog.program_occupation_id,
        program_name          : prog.program_name,
        occupation_name       : prog.occupation_name,
        program_type          : prog.type,
        title                 : prog.title,
        categoryId            : getProgramCategoryId(prog),
        ...addr,
      } 
      // add to accumulator array
      addrAcc.push(mapped)
      // increment index
      addressIndex += 1
      return addrAcc
    }, [])
    // add mapped addresses to accumulator
    progAcc.locations = [ ...progAcc.locations, ...mappedAddresses, ]
    return progAcc
  }, { locations: [], bounds: null, })

  return reducedPrograms
}


export const filterAndRecalculateBounds = (locations, id, type, categoryId) => {
  if (!_.isArray(locations)) {
    return { locations: [], bounds: null, center: null, zoom: null, }
  }
  const locationData = locations.reduce((prev, curr) => {
    if (((!id || !type) || (curr.program_occupation_id === id && curr.program_type === type)) && (!categoryId || categoryId === curr.categoryId)) {
      prev.locations.push(curr)
      if (!prev.bounds) {
        prev.bounds = new google.maps.LatLngBounds()
      }
      prev.bounds.extend({ lat: curr.lat, lng: curr.lon, })
    }
    return prev
  }, { locations: [], bounds: null, center: null, zoom: null, })

  if (locationData.bounds) {
    locationData.center = locationData.bounds.getCenter()
  }

  if (locationData.locations.length === 1) {
    locationData.zoom =  10
  } else if (locationData.locations.length > 1) {
    locationData.zoom =  9
  }

  return locationData
}
